// 2020-06-27export { TropaReporteEdicionComponent } from './tropa-reporte-edicion.component';